import {ProductInterface} from "../../interfaces/product/ProductInterface";
import {Link} from "react-router-dom";
import {PROPERTY_KEY_BRAND_ORIGIN} from "../../Config";
import BrandLink from "./BrandLink";
import {getBrandDescription} from "./brandDescriptions";

export default function BrandInfo({product}: { product: ProductInterface }) {
    const brandDescription = getBrandDescription(product.normalized_brand_name);

    const normalizeCountryName = (name: string) => {
        return name.toLowerCase().replace(/[^а-яa-z]/g, '');
    }

    const flags: Record<string, string> = {
        [normalizeCountryName('ТАЙВАНЬ (КИТАЙ)')]: 'icon-taiwan.svg',
        [normalizeCountryName('ТАЙВАНЬ')]: 'icon-taiwan.svg',
        [normalizeCountryName(' ИНДИЯ')]: 'icon-india.svg',
        [normalizeCountryName('КИТАЙ')]: 'icon-kit.svg',
        [normalizeCountryName('Россия')]: 'icon-ros.svg',
    }

    const parseItemText = (text: string) => {
        const categoryMatch = text.match(/\[#(\d+)\/([^#]+)#\]/);
        if (categoryMatch) {
            const rawPrefix = categoryMatch[2];
            const cleanText = text.replace(/\[#[^#]+#\]/, '').trim();
            return { href: `/catalog/by-code/${rawPrefix}`, text: cleanText };
        }

        const codeMatch = text.match(/\[%(\d+)%\]/);
        if (codeMatch) {
            const code = codeMatch[1];
            const cleanText = text.replace(/\[%\d+%\]/, '').trim();
            return { href: `/catalog/item-by-code/${code}`, text: cleanText };
        }

        return { href: null, text };
    }


    return (<div className="d-flex flex-column prod-pane__right">
        <div className="prod-pane__brand pane-brand d-flex flex-column">
            <div className="pane-brand__head d-flex justify-content-between gap-3 ">
                <div className="pane-brand__head-body d-flex justify-content-between align-items-center w-100">
                    <div className="pane-brand__text-logo d-flex align-items-center">
                        <div className="pane-brand__logo">
                            <img className="w-100" src={'https://www.pride.ru/images/logos/' + product.brand_name.toLowerCase() + '.svg'} alt=""/>
                        </div>
                        {brandDescription && <button
                            type="button"
                            className="pane-brand__hint"
                            aria-label={`Кратко о бренде ${product.brand_name}`}
                            aria-describedby="brand-description-tooltip"
                        >
                            <img src="/images/logo-hint.svg" alt=""/>
                            <span id="brand-description-tooltip" className="pane-brand__tooltip" role="tooltip">
                                {brandDescription}
                            </span>
                        </button>}
                    </div>
                    <BrandLink brandName={product.brand_name}/>

                </div>
            </div>
            <div className="pane-brand__bot d-flex justify-content-between align-items-center">
                <div className="pane-brand__bot-item d-flex align-items-center">
                    {flags[normalizeCountryName(product.properties[PROPERTY_KEY_BRAND_ORIGIN]?.[0] || '')] && <img
                        src={'/images/' + flags[normalizeCountryName(product.properties[PROPERTY_KEY_BRAND_ORIGIN]?.[0] || '')]}
                        alt=""/>}
                    <p>{product.properties[PROPERTY_KEY_BRAND_ORIGIN]?.[0]} – родина бренда</p>
                </div>
                <div className="pane-brand__bot-item d-flex align-items-center">
                    {flags[normalizeCountryName(product.additional_params?.country || '')] &&
                        <img src={'/images/' + flags[normalizeCountryName(product.additional_params?.country || '')]}
                             alt=""/>}
                    <p>{product.additional_params?.country} – страна производства</p>
                </div>
            </div>
        </div>
        {product.additional_params?.specification_list_raw?.length &&
            <div className="d-flex flex-column prod-pane__right-body">
                <p className="fw-bold text-uppercase">комплектация</p>
                <ul className="d-flex flex-column">
                    {product.additional_params.specification_list_raw.map((item, index) => {
                        const {href, text} = parseItemText(item);
                        return (
                            <li key={index}>
                                {text.trim() && <span className="t-orange cicle">●</span>}
                                {href ? (
                                    <Link to={href}
                                          className="t-orange text-decoration-underline">{text}</Link>
                                ) : (
                                    <span>{text}</span>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </div>}
    </div>)
}
